import { notification } from 'antd';
import { ReactComponent as Success } from 'assets/icons/success.svg';

export const triggerNotification = ({
  message,
  description,
  onClick,
  duration = 3,
  Icon,
}) => {
  const language = localStorage.getItem('appLanguage') || process.env.REACT_APP_DEFAULT_APP_LANGUAGE;

  const messages = {
    GR: {
      message: 'Επιτυχής Αποθήκευση Αίτησης',
      description: 'Τα στοιχεία της αίτησης σας αποθηκεύτηκαν επιτυχώς.'
    },
    UK: {
      message: 'Application Saved Successfully',
      description: 'Your application details have been successfully saved.'
    }
  };

  const selectedMessages = messages[language] || messages.GR;

  notification.open({
    message: message || selectedMessages.message,
    description: description || selectedMessages.description,
    onClick,
    duration,
    icon: Icon ? <Icon /> : <Success />,
  });
};